<template>
  <div class="h-full">
    <div v-if="isExam" class="h-full flex flex-col">
      <div
        class="flex items-center justify-end pb-10px border-b border-color-default border-dotted"
      >
        <div class="flex items-center mr-10px">
          <span
            class="border-color-primary border inline-block rounded-full w-16px h-16px mr-6px"
          ></span>
          已作答
        </div>
        <div class="flex items-center mr-10px">
          <span
            class="border-color-default border inline-block rounded-full w-16px h-16px mr-6px"
          ></span>
          未作答
        </div>
        <span class="mr-10px ">
          <span class="text-blue-500">{{ complete }}</span
          >/{{ total }}
        </span>
        <span class="text-34px text-red-500">{{ countdownDisplay }}</span>
      </div>
      <!-- 答题卡 -->
      <div>
        <div class="px-20px bg-color-primary w-141px m-auto cursor-pointer" @click="handelCard">
          答题卡{{ isOpen ? '收缩' : '展开' }}
          <i :class="isOpen ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
        <div :style="{ 'max-height': cardHeight, overflow: 'auto' }" class="card_animate">
          <div v-for="(item, index) in answerSheetList" :key="index">
            <template v-if="item.list.length">
              <div>{{ item.name }}</div>
              <div class="pl-15px flex flex-wrap">
                <span
                  v-for="(sortItem, sortIndex) in item.list"
                  :key="sortIndex"
                  class="w-36px h-36px rounded-full flex items-center justify-center mr-20px border my-10px cursor-pointer"
                  :class="
                    isValue(sortItem.examineeAnswerContent)
                      ? ['border-color-primary', 'text-primary-cus'].join(' ')
                      : 'border-color-default'
                  "
                  @click="scrollPosition(item.examType + '_' + sortIndex)"
                >
                  {{ sortIndex + 1 }}
                </span>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- 题目 -->
      <div class="flex-1 overflow-y-auto">
        <div v-for="(item, index) in answerSheetList" :key="index">
          <template v-if="item.list.length">
            <div>{{ item.name }}</div>
            <div>
              <div
                v-for="(sortItem, sortIndex) in item.list"
                :key="sortIndex"
                :id="item.examType + '_' + sortIndex"
              >
                <div>
                  {{ sortIndex + 1 }}、
                  <span>({{ item.examType | typeStr }})</span>
                  {{ sortItem.topic }}
                </div>
                <div v-if="item.examType === 0" class="my-10px">
                  <el-radio-group v-model="sortItem.examineeAnswerContent">
                    <ByChoice
                      type="radio"
                      v-model="sortItem.examineeAnswerContent"
                      :optionsString="sortItem.topicContent"
                      @change="saveAnswer(sortItem)"
                    />
                  </el-radio-group>
                </div>
                <div v-if="item.examType === 1" class="my-10px">
                  <ByChoice
                    v-model="sortItem.examineeAnswerContent"
                    :optionsString="sortItem.topicContent"
                    @change="saveAnswer(sortItem)"
                  />
                </div>
                <div v-if="item.examType === 2" class="my-10px">
                  <el-radio-group v-model="sortItem.examineeAnswerContent">
                    <ByChoice
                      type="judge"
                      v-model="sortItem.examineeAnswerContent"
                      :optionsString="sortItem.topicContent"
                      @change="saveAnswer(sortItem)"
                    />
                  </el-radio-group>
                </div>
                <div v-if="item.examType === 3" class="my-10px">
                  <el-input
                    class="!w-50"
                    v-model="sortItem.examineeAnswerContent"
                    maxlength="50"
                    show-word-limit
                    @blur="saveAnswer(sortItem)"
                  >
                  </el-input>
                </div>
                <div v-if="item.examType === 4" class="my-10px">
                  <el-input
                    v-model="sortItem.examineeAnswerContent"
                    type="textarea"
                    :rows="3"
                    maxlength="500"
                    show-word-limit
                    @blur="saveAnswer(sortItem)"
                  >
                  </el-input>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="text-center">
        <el-button
          size="small"
          type="primary"
          v-loading="formLoading"
          class="iconfont icon-save"
          :disabled="!!isCanSubmit"
          @click="save()"
          >提交试卷&nbsp;{{ isCanSubmit ? `(${isCanSubmit})` : '' }}</el-button
        >
      </div>
      <!-- 提交试卷 -->
      <el-dialog
        :visible.sync="submitDialog"
        @close="submitDialog = false"
        width="30%"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        v-dialogDrag
      >
        <span slot="footer" class="text-center">
          <el-button type="primary" size="small">确 定</el-button>
          <el-button @click="submitDialog = false" size="small">取 消</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-else class="h-full flex items-center justify-center">
      <template v-if="!markingPaper">
        <el-result>
          <template slot="icon">
            <i class="el-icon-loading" />
            <span class="ml-10px">已经提交考试试卷，请耐心等待考试结果</span>
          </template>
          <template slot="extra">
            <el-button @click="back" type="primary" size="small">我知道了</el-button>
          </template>
        </el-result>
      </template>
      <template v-else>
        <el-result
          :icon="isPass ? 'success' : 'warning'"
          :title="
            isPass
              ? `恭喜您通过考试，本次考试成绩：${paperTotalScore}分。`
              : `很遗憾，您未能通过此次考试，本次考试成绩：${paperTotalScore}分。`
          "
        >
          <template slot="extra">
            <el-button @click="back" type="primary" size="small">我知道了</el-button>
          </template>
        </el-result>
      </template>

      <!-- <el-result icon="success" title="试卷成功提交">
        <template slot="extra">
          <el-button @click="back" type="primary" size="small">我知道了</el-button>
        </template>
      </el-result> -->
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { OnlineExamsApi, ExamTaskApi } from '@wiz-api/exam-management'
import utils from '@/components/safety/enumField/utils'
import ByChoice from './ByChoice'

const onlineExamsApi = new OnlineExamsApi()
const examTaskApi = new ExamTaskApi()

export default {
  name: 'question-task-form',
  components: {
    ByChoice,
  },
  props: {
    // 是否替换路由
    isNeedReplaceRoute: {
      type: String,
      default: '0',
    },
  },
  filters: {
    typeStr(examType) {
      switch (examType) {
        case 0:
          return '单选题'
        case 1:
          return '多选题'
        case 2:
          return '判断题'
        case 3:
          return '填空题'
        case 4:
          return '问答题'
        default:
          return ''
      }
    },
  },
  data() {
    return {
      options: [
        { label: 'A选项', value: 'A' },
        { label: 'B选项', value: 'B' },
        { label: 'C选项', value: 'C' },
        { label: 'D选项', value: 'D' },
      ],
      isOpen: true,
      formLoading: false,
      submitDialog: false,
      isExam: true,
      isPass: true,
      paperTotalScore: 0,
      // 是否阅卷
      markingPaper: false,
      isResult: true,
      // 答题卡
      answerSheetList: [
        {
          examType: 0,
          name: '一、单选题(共5题，共10分)',
          list: [],
        },
        {
          examType: 1,
          name: '二、多选题(共5题，共10分)',
          list: [],
        },
        {
          examType: 2,
          name: '三、判断题(共5题，共10分)',
          list: [],
        },
        {
          examType: 3,
          name: '四、填空题(共5题，共10分)',
          list: [],
        },
        {
          examType: 4,
          name: '五、问答题(共5题，共10分)',
          list: [],
        },
      ],
      formData: {},
      timer: null,
      getTimer: null,
      countdownDisplay: '',
      isCanSubmit: '',
      isCanSubmitEnum: 0,
    }
  },
  computed: {
    cardHeight() {
      return this.isOpen ? '270px' : 0
    },
    complete() {
      let count = 0
      this.answerSheetList.forEach((item) => {
        item.list.forEach((topic) => {
          topic.examineeAnswerContent ? (count += 1) : count + 1
        })
      })
      return count
      // if (!this.formData.examPapers) {
      //   return 0
      // }
      // const allList = this.formData.examPapers.reduce((pre, item) => {
      //   pre = [...pre, ...item.examPaperSourceCorrelations]
      //   return pre
      // }, [])
      // return allList.reduce((pre, item) => {
      //   if (
      //     item.examineeAnswerContent ||
      //     item.examineeAnswerContent === 0 ||
      //     item.examineeAnswerContent === false
      //   ) {
      //     pre = pre + 1
      //   }
      //   return pre
      // }, 0)
    },
    total() {
      // return Object.keys(this.formData).length
      return this.answerSheetList.reduce((pre, item) => {
        pre = pre + item.list.length
        return pre
      }, 0)
    },
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
  },
  watch: {},
  created() {
    this.getTopic()
  },
  mounted() {},

  methods: {
    // 返回
    async back() {
      if (this.isNeedReplaceRoute === '1') {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== '/educational-training-management-sm/exam-manage/question-task'
            })
          )
        }
        this.$router.go(-2)
      } else {
        this.$router.go(-1)
      }
    },
    async getTopic() {
      const examTaskId = this.$route.query.id
      const [err, res] = await onlineExamsApi.startExam({ body: { examTaskId } })
      if (!err) {
        this.formData = res
        this.setTime(res.singleExamEndTime, true)
        this.getTimer = setTimeout(() => {
          this.getEndTime()
        }, 5000)
        const listTypes = this.formData.examPaperContent.topicTypes
        const copyAnswerSheetList = JSON.parse(JSON.stringify(this.answerSheetList))
        let typeIndex = 1
        copyAnswerSheetList.forEach((item) => {
          item.list =
            listTypes.find((i) => {
              return item.examType === i.questionType
            })?.topicContents || []
          const total = item.list.length
          const totalPoints = item.list.reduce((pre, i) => {
            pre = pre + i.score
            return pre
          }, 0)
          if (item.list.length) {
            item.typeIndex = typeIndex
            typeIndex += 1
          }
          switch (item.examType) {
            case 0:
              item.name = `${utils.numToChines(
                item.typeIndex
              )}、单选题(共${total}题，共${totalPoints}分)`
              break
            case 1:
              item.name = `${utils.numToChines(
                item.typeIndex
              )}、多选题(共${total}题，共${totalPoints}分)`
              break
            case 2:
              item.name = `${utils.numToChines(
                item.typeIndex
              )}、判断题(共${total}题，共${totalPoints}分)`
              break
            case 3:
              item.name = `${utils.numToChines(
                item.typeIndex
              )}、填空题(共${total}题，共${totalPoints}分)`
              break
            case 4:
              item.name = `${utils.numToChines(
                item.typeIndex
              )}、问答题(共${total}题，共${totalPoints}分)`
              break
            default:
              break
          }
        })
        this.answerSheetList = copyAnswerSheetList
      }
    },
    save() {
      this.$confirm('试卷提交后不可修改，请认真核对考试答案', '是否确认提交试卷？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(async () => {
          clearInterval(this.timer)
          this.submit()
        })
        .catch(() => {})
    },
    async submit(isAuto = false) {
      // 处理日期格式
      if (this.formData.examEndTime) {
        this.formData.examEndTime = dayjs(this.formData.examEndTime).format('YYYY-MM-DD HH:mm:ss')
      }
      if (this.formData.examStartTime) {
        this.formData.examStartTime = dayjs(this.formData.examStartTime).format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }
      if (this.formData.examPaperContent.examStartTime) {
        this.formData.examPaperContent.examStartTime = dayjs(
          this.formData.examPaperContent.examStartTime
        ).format('YYYY-MM-DD HH:mm:ss')
      }
      if (this.formData.examPaperContent.examEndTime) {
        this.formData.examPaperContent.examEndTime = dayjs(
          this.formData.examPaperContent.examEndTime
        ).format('YYYY-MM-DD HH:mm:ss')
      }
      if (this.formData.singleExamStartTime) {
        this.formData.singleExamStartTime = dayjs(this.formData.singleExamStartTime).format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }
      if (this.formData.singleExamEndTime) {
        this.formData.singleExamEndTime = dayjs(this.formData.singleExamEndTime).format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }
      this.formData.examTaskId = this.$route.query.id
      const [err, res] = await onlineExamsApi.submit({ body: this.formData })
      if (!err) {
        // 是否阅卷
        this.markingPaper = res.markingPaper
        // 是否通过
        this.isPass = res.isPass
        this.paperTotalScore = res.examPaperContent.paperTotalScore
        if (isAuto) {
          this.$alert('已经达到考试时间，系统自动交卷', '试卷已经提交', {
            confirmButtonText: '确定',
            type: 'success',
            center: true,
          })
            .then(async () => {
              this.goResult()
            })
            .catch(() => {})
        } else {
          this.goResult()
          // this.$alert('', '已经提交考试试卷，请耐心等待开始结果', {
          //   confirmButtonText: '返回',
          //   type: 'success',
          //   center: true,
          // })
          //   .then(async () => {
          //     this.goResult()
          //   })
          //   .catch(() => {})
        }
      }
    },
    async goResult() {
      if (this.isResult) {
        this.isExam = false
        return
      }
      if (this.isNeedReplaceRoute === '1') {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== '/educational-training-management-sm/exam-manage/question-task'
            })
          )
        }
        this.$router.go(-2)
      } else {
        this.$router.go(-1)
      }
    },
    isValue(value) {
      if (value || value === 0 || value === false) {
        return true
      }
      return false
    },
    async getEndTime() {
      if (this.getTimer === null || !this.isExam) return
      const [err, res] = await examTaskApi.getExamPlanEndTime(this.formData.id)
      if (!err) {
        const answerTime = dayjs(this.formData.singleExamEndTime).diff(
          this.formData.singleExamStartTime,
          'minutes'
        )
        if (answerTime < this.formData.answerTime) {
          const maxTime = dayjs(this.formData.singleExamStartTime).add(
            this.formData.answerTime,
            'minutes'
          )
          const endTime = maxTime.isAfter(res) ? res : maxTime
          const updateSubmit =
            answerTime < 15 &&
            dayjs(endTime).diff(this.formData.singleExamStartTime, 'minutes') >= 15
          clearInterval(this.timer)
          this.setTime(endTime, updateSubmit)
          this.formData.singleExamEndTime = endTime
        }
        this.getTimer = setTimeout(() => {
          this.getEndTime()
        }, 60000)
      }
    },
    setTime(endTime, updateSubmit = false) {
      const that = this
      // const endTime = new Date() // 获取当前时间
      // endTime.setHours(endTime.getHours() + 2) // 设置考试结束时间为2小时后
      if (updateSubmit) {
        this.isCanSubmitEnum = this.$options.data().isCanSubmitEnum
      }
      function updateCountdown() {
        const now = new Date() // 获取当前时间
        const timeDiff = new Date(endTime) - now // 计算剩余时间的毫秒数

        if (timeDiff <= 0) {
          that.submit()
          that.timer && clearInterval(that.timer) // 倒计时结束，清除定时器
        } else {
          let hours = Math.floor(timeDiff / 3600000) // 计算剩余小时数
          let minutes = Math.floor((timeDiff % 3600000) / 60000) // 计算剩余分钟数
          let seconds = Math.floor((timeDiff % 60000) / 1000) // 计算剩余秒数

          hours = hours < 10 ? `0${hours}` : hours
          minutes = minutes < 10 ? `0${minutes}` : minutes
          seconds = seconds < 10 ? `0${seconds}` : seconds

          that.countdownDisplay = `${hours}:${minutes}:${seconds}`
        }
        if (timeDiff > that.isCanSubmitEnum && that.isCanSubmitEnum >= 0) {
          let minutes = Math.floor((that.isCanSubmitEnum % 3600000) / 60000) // 计算剩余分钟数
          let seconds = Math.floor((that.isCanSubmitEnum % 60000) / 1000) // 计算剩余秒数
          minutes = minutes < 10 ? `0${minutes}` : minutes
          seconds = seconds < 10 ? `0${seconds}` : seconds
          that.isCanSubmit = `${minutes}:${seconds}`

          if (that.isCanSubmitEnum === 0) {
            that.isCanSubmit = 0
          }
          that.isCanSubmitEnum -= 1000
        }
      }

      updateCountdown() // 首次调用更新倒计时
      this.timer = setInterval(updateCountdown, 1000) // 每秒调用一次更新倒计时
    },

    handelCard() {
      this.isOpen = !this.isOpen
    },
    scrollPosition(idCode) {
      const el = document.getElementById(idCode)
      el.scrollIntoView(true)
    },
    async saveAnswer(row) {
      // 做一题保存一次
      // taskExamAnswerId 等待返回
      const data = {
        taskExamAnswerId: this.formData.taskExamAnswerId,
        updateTopicContent: row,
      }
      await onlineExamsApi.saveExamAnswerContent({ body: data })
    },
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.getTimer) {
      clearInterval(this.getTimer)
      this.getTimer = null
    }
  },
  deactivated() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.getTimer) {
      clearInterval(this.getTimer)
      this.getTimer = null
    }
  },
}
</script>

<style scoped lang="scss">
.card_animate {
  overflow: hidden;
  transition: 0.5s;
}
.text-primary-cus {
  color: var(--systemMainColor);
}
</style>
